export default __webpack_public_path__ + "static/car7-614ea66a65c1ad6c844d7f0c413ed8fe.glb";